import { Input, } from "@basic-components";
const { TextArea } = Input;

export const Textarea = ({ label = '', isView, value, ...rest }: { label: string; isView?: boolean } & any) => {

  if (isView) {
    return (
      <div 
        style={{
          whiteSpace: 'pre-wrap',
          wordWrap: 'break-word',
        }}
      >
        {value || '--'}
      </div>
    );
  }

  return <TextArea placeholder={`请输入${label}`} value={value} {...rest}/>;
};